import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';    
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';           
import { Rank } from '@ascschool/model/category/rank.model';
import { DegreeService } from '@ascschool/services/category/degree.service';
import { Degree } from '@ascschool/model/category/degree.model';
import { CertificateTakeCareOfStudent } from '@ascschool/model/school/certificate-take-care-of-student.model';
import { CustomResponse } from '@ascschool/model/custom-response.model';
import { PolicyOfStudent } from '@ascschool/model/school/policy-of-student.model';

@Component({
  selector: 'app-policy-of-student-add-popup',
  templateUrl: './policy-of-student-add-popup.component.html',
  styleUrls: ['./policy-of-student-add-popup.component.scss']
})
export class PolicyOfStudentAddPopupComponent implements OnInit {
  @Input() type: any;
  @Input() dataTransmission: any;
  itemPolicy: PolicyOfStudent = new PolicyOfStudent();
  response: CustomResponse = new CustomResponse(); 
  isEditMode = false; 
  errorMsg: string;
  isDisabled = false;
  validateForm!: FormGroup; 
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService, 
    public utilsService: UtilsService, 
  ) {
  }

  ngOnInit() {
    if ( this.dataTransmission) {
      this.itemPolicy = Object.assign({}, this.dataTransmission);
    }

  }
  UpdateClose() {
    if (this.itemPolicy.policyName && this.itemPolicy.policyName != '') {
      this.response.data = this.itemPolicy;
      this.response.status = true;
      this.modal.close(this.response);
      this.msg.success('Thành công');
    } else {
      this.msg.warning('Vui lòng nhập trường bắt buộc');
    }
  }
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(this.response);
  }
  
  notification(response){
    if (response.statusCode === 0){
      this.msg.success('Cập nhật thông tin: ' + response.message);
    }else{
      this.msg.error('Lỗi: ' + response.message);
    }
  }
  onChange(result: Date[]): void {
    console.log('onChange: ', result);
  }
}
